import { render, staticRenderFns } from "./OpeningBalanceModal.vue?vue&type=template&id=60c6146a&"
import script from "./OpeningBalanceModal.vue?vue&type=script&lang=js&"
export * from "./OpeningBalanceModal.vue?vue&type=script&lang=js&"
import style0 from "./OpeningBalanceModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports